document.addEventListener('DOMContentLoaded', function() {
    const productRelatedSection = themeObject.productRelatedSection;

    if (!productRelatedSection) {
        return;
    }

    const observer = new IntersectionObserver(async (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(productRelatedSection);

        try {
            const response = await fetch(productRelatedSection.dataset.url);
            const text = await response.text();
            const parser = new DOMParser();
            const htmlDocument = parser.parseFromString(text, 'text/html');
            const related = htmlDocument.querySelector('.product-related');

            if (related && related.innerHTML.trim().length) {
                productRelatedSection.innerHTML = related.innerHTML;
            }
        } catch (e) {
            console.error('Error fetching and parsing related products:', e);
        }
    }, { rootMargin: '0px 0px 100px 0px' });

    observer.observe(productRelatedSection);
});
